const getSizeClass = (size) => {
	const normalizedSize = size.toLowerCase();

	if (normalizedSize === "large") {
		return "sizeLarge";
	}

	if (normalizedSize === "extralarge") {
		return "sizeExtraLarge";
	}

	return "sizeSmall";
};

export default getSizeClass;
